import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';

import ProjectReports from '../pages/project-reports';
import ChangeImpactReports from '../pages/change-impact-reports';

export const reportRoutes = () => (
  <>
    <Route path={ROUTES.PROJECT_REPORTS} element={<ProjectReports />} />
    <Route
      path={ROUTES.CHANGE_IMPACT_REPORTS}
      element={<ChangeImpactReports />}
    />
  </>
);
